import throttle from 'lodash.throttle';
import React from 'react';
import styled from '@emotion/styled'
import { containers, MixBlendDifference } from 'style';

class CaseSectionComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      caseSections: props.caseSections
    }

    this.handleResize = this.handleResize.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.trottledScroll = throttle(this.handleScroll, 500);
  }

  componentDidMount() {
    if (this.props.caseSections.length) {
      this.handleResize();
      this.addEventListeners();
    }
  }
  componentWillUnmount() {
    this.removeEventListeners();
  }
  handleScroll() {
    if (this.state.caseSections.length) {
      const caseSections = this.state.caseSections;
      let activeElement = null;
      caseSections.forEach((element, i) => {
        element.active = false;
        if (window.pageYOffset > element.top) {
          activeElement = i;
        }
      });
      if (activeElement != null) {
        caseSections[activeElement].active = true;
      }
      this.setState({ caseSections: caseSections });
    }
  }
  handleResize() {
    const caseSections = this.state.caseSections;
    caseSections.forEach(element => {
      element.top = document.querySelector(`#${element.id}`).getBoundingClientRect().top + window.pageYOffset;
      element.active = false;
    });
    this.setState({ caseSections: caseSections });
    this.handleScroll();
  }
  addEventListeners() {
    window.addEventListener('scroll', this.trottledScroll);
    window.addEventListener('resize', this.handleResize);
  }

  removeEventListeners() {
    window.removeEventListener('scroll', this.trottledScroll);
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    const { caseSections } = this.state;
    return (

      <CaseSection id="CaseSectionComponent">
        {caseSections.map((el) => <div key={`section_${el.id}`} className={el.active ? 'active' : ''}>{el.sectionTitle}</div>)}
      </CaseSection>
    )
  }
}

const CaseSection = styled.div`
    position: fixed;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    z-index: 100;

    /* @media (min-width: 1024px){
      left: 7px;
      top: 50%;
      transform: translateY(-50%);
    } */

    ${MixBlendDifference}
    pointer-events: none;
    div{

      /* padding: 20px; */
      line-height: ${100 / 18 * 4}vw;

      @media (min-width: ${containers.ipad}px){
        line-height: ${100 / 18 * 2}vw;
      }
      opacity: .5;
      display: none;
      /* @media (min-width: 1024px){
        writing-mode: tb;
        transform: rotate(180deg);
        display: block;
      } */
      &.active{
        display: block;
        opacity: 1;
      }
    }

`;

export default CaseSectionComponent;
